export default __webpack_public_path__ + "static/media/Group1142.50174cae.svg";